module.exports = "function logProps(WrappedComponent) {\n  return class extends React.Component {\n\n    componentWillReceiveProps(nextProps) {\n      console.log(`Next props: ${nextProps}`);\n    }\n\n    render() {\n      return (\n        <WrappedComponent {...this.props} />;\n      )\n    }\n  }\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/12_beyond_basics/hoc.example
// module id = 1538
// module chunks = 0